import LocalStorageService from '../../../Services/Storage/LocalStorageService';

/**
 * Class Menu Account.
 */
export default class AccountHeader {
  static keyName = 'userData';

  /*
   * User login in menu account Desktop
   * */
  public static menuDesktop() {
    const menuAccountElement: HTMLElement =
      document.querySelector('.c-menuAccount');

    if (menuAccountElement) {
      const { firstname } = AccountHeader.updateUserName();

      // Login user
      if (firstname) {
        const titleNameTextElement: HTMLElement = document.querySelector(
          '.c-menuAccount__titleName .c-menuAccount__name'
        );

        // Add login class
        menuAccountElement.classList.add('c-menuAccount--login');

        // Add name to title
        if (titleNameTextElement) {
          titleNameTextElement.textContent = `${firstname}`;
        }
      } else {
        const createAccountElement: HTMLElement = document.querySelector(
          '.c-menuAccount__creat'
        );
        const titleNameElement: HTMLElement = document.querySelector(
          '.c-menuAccount__titleName'
        );

        // Add logout class
        menuAccountElement.classList.add('c-menuAccount--logout');

        // Add create
        createAccountElement.classList.add('is-enable');

        titleNameElement.classList.add('is-disable');
      }
    }
  }

  /*
   * Add name & firstname in header
   * */
  public static updateUserName(): { firstname: string } {
    const isDisableLocalStorage = AccountHeader.isDisableLocalStorage();
    const serviceStorage = new LocalStorageService();
    const userData: { firstname?: string; name?: string; wishlist?: boolean } =
      serviceStorage.getItem(AccountHeader.keyName);

    let firstname: string | null;
    let wishlist: boolean;

    if (userData?.firstname && !isDisableLocalStorage) {
      // Read data in LocalStorage
      firstname = userData.firstname;
      wishlist = userData.wishlist;
    } else {
      // Create data in LocalStorage
      const firstnameDataElement: HTMLInputElement = document.querySelector(
        '#data-header-firstname'
      );
      firstname =
        firstnameDataElement && firstnameDataElement.value
          ? firstnameDataElement.value
          : null;

      const wishlistDataElement: HTMLInputElement = document.querySelector(
        '#data-wishlist-products'
      );
      const wishlistArray: [] =
        wishlistDataElement && wishlistDataElement.value
          ? JSON.parse(wishlistDataElement.value)
          : [];

      wishlist = Array.isArray(wishlistArray)
        ? wishlistArray.length > 0
        : false;

      // Push to local storage
      serviceStorage.setItem(AccountHeader.keyName, {
        firstname,
        wishlist,
      });
    }

    // Dot Wishlist in Header
    this.dotWishlist(wishlist);

    return {
      firstname,
    };
  }

  /*
   * Disable LocalStorage in specific page
   * */
  static isDisableLocalStorage(): boolean {
    const body: HTMLElement = document.querySelector('body');
    const isAccountPage = body.classList.contains('mes-commandes');
    const isNewCartPage = !!document.querySelector('.l-cart');
    const isNewCheckoutPage = !!document.querySelector('.l-checkout');
    const isNewConnexionPage = body.classList.contains('l-authentication');
    const isNewCheckoutSuccessPage =
      body.classList.contains('l-checkout-success');

    return (
      isAccountPage ||
      isNewCartPage ||
      isNewCheckoutPage ||
      isNewConnexionPage ||
      isNewCheckoutSuccessPage
    );
  }

  /*
   * Add dot Wishlist in header
   * */
  private static dotWishlist(wishlist: boolean) {
    const wishlistHeaderElement: HTMLElement = document.querySelector(
      '.c-menuTertiary__item--wishlist'
    );

    if (wishlist) {
      const dot = document.createElement('span');
      dot.classList.add('c-menuTertiary__dot');

      if (wishlistHeaderElement) {
        wishlistHeaderElement.appendChild(dot);
      }
    }
  }
}
